export default "__VITE_ASSET__8d2d7cc3__"